<template>
  <v-container style="min-width: 20em; max-width: 30em">
    <v-row :justify="align" class="title">
      {{ now || title }}
    </v-row>
    <v-row :justify="align" class="caption">
      {{ 'Darrera actualització: ' + last_updated || title }}
    </v-row>
  </v-container>
</template>

<script>
 
</script>
<script>
 import { mapState } from 'vuex';
 import units from '@/units';
 import utils from '@/utils';

 export default {
   name: 'UpdatedClock',

   props: {
     align: {
       default: 'end',
     }
   },

   components: {
   },

   data: () => ({
     //
   }),

   computed: {
     ...mapState(['loading', 'last']),

     now() {
       const dt = new Date();
       return (units.date2locale_date(dt)
             + ' a les '
             + utils.left_pad(''+dt.getHours(), '0', 2)
             + ':'
             + utils.left_pad(''+dt.getMinutes(), '0', 2));
     },

     last_updated() {
       let dt;
       if (this.last && this.last.datetime) {
         dt = new Date(this.last.datetime);
         let text = (units.date2locale_date(dt)
                   + ' a les '
                   + utils.left_pad(''+dt.getHours(), '0', 2)
                   + ':'
                   + utils.left_pad(''+dt.getMinutes(), '0', 2));
         let last_parts = text.split(' ');
         let now_parts  = this.now.split(' ');
         let final = utils.substract_string_start(now_parts, last_parts)[1];
         return final.join(' ') || 'ara mateix';
       }
       return null;
     }
   },
 };
</script>
